import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPaperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 23"
    fill="none"
    stroke="#007AFF"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m15.405 13.17-3.34 5.787a5.749 5.749 0 0 1-9.958-5.748l5.729-9.922a3.797 3.797 0 0 1 6.576 3.798l-5.77 9.994a1.888 1.888 0 1 1-3.27-1.888l4.953-8.58" />
  </svg>
);
const Memo = memo(SvgPaperclip);
export default Memo;
